import React from 'react';
import { Table } from '../common';
import AWSPortOpeningRequest from '../../models/entities/AWSPortOpeningRequests';
import ProgressBarSmall from '../AWSPortOpeningRequests/components/ProgressBarSmall';
import { useNavigate } from 'react-router-dom';
import './ApprovalsAWSPORsTableRow.css';
import { Button } from '../common';

interface ApprovalsAWSPORsTableRowProps {
	awsPor: AWSPortOpeningRequest;
}

const ApprovalsAWSPORsTableRow = ({ awsPor }: ApprovalsAWSPORsTableRowProps) => {
	const navigate = useNavigate();
	const handleViewDetails = () => {
		navigate(`/accounts/${awsPor.accountId}/awsPortOpeningRequests/${awsPor.id}`);
	};

	return (
		<Table.Row>
			<Table.Cell>#{awsPor.id}</Table.Cell>
			<Table.Cell className="em-u-text-align-center">{awsPor.accountName}</Table.Cell>
			<Table.Cell className="em-u-text-align-center center-align">
				<ProgressBarSmall
					workflowState={awsPor.workflowInstance.currentWorkflowInstanceState.workflowState}
					porScope={awsPor.direction?.name}
				/>
			</Table.Cell>
			<Table.Cell className="em-u-text-align-center">
				<Button style={{ width: 120, height: 34 }} onClick={handleViewDetails} variant="primary">
					See Details
				</Button>
			</Table.Cell>
		</Table.Row>
	);
};

export default ApprovalsAWSPORsTableRow;
